// An Event detail's guests: counts per status, each opening its list.
// Entries are the series RSVPs (EventSerializer.rsvps: { id, username,
// status }) or one occurrence's guests (EventOccurrenceDetailSerializer.rsvps:
// { user, username, status, has_override }). Whoever the backend lists is
// shown — it lists everyone only to the creator, and other guests who are
// going only to a viewer who's going.

// Order + labels. "invited" means pending/unanswered, matching the backend's
// own EventRSVP.STATUS values.
const GUEST_STATUSES = [
  { status: "invited", label: "invited" },
  { status: "going", label: "going" },
  { status: "declined", label: "declined" },
];

// Non-empty categories only. → [{ status, label, users }]
export function guestStats(guests) {
  return GUEST_STATUSES.map(({ status, label }) => ({
    status,
    label,
    users: (guests || []).filter((g) => g.status === status),
  })).filter((s) => s.users.length > 0);
}

export function GuestSummary({ stats, onOpen }) {
  if (stats.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-4">
      {stats.map((s) => (
        <button
          key={s.status}
          type="button"
          onClick={() => onOpen(s.status)}
          className="text-xs text-gray-500 hover:text-blue-500 hover:underline"
        >
          {s.users.length} {s.label}
        </button>
      ))}
    </div>
  );
}

// has_override is only ever set for the creator, so nothing about how other
// guests take part in the series is shown to anyone else.
export function GuestList({ stat, status, onBack }) {
  const users = stat?.users || [];
  return (
    <div
      className="bg-white rounded-lg shadow-lg w-full max-w-md p-5 max-h-[85vh] overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <button type="button" onClick={onBack} className="text-xs text-gray-500 hover:text-blue-500 mb-3">
        ← Back
      </button>
      <h3 className="text-sm font-semibold capitalize mb-2">{stat?.label || status}</h3>
      <ul className="divide-y divide-gray-100">
        {users.map((r) => (
          <li key={r.id ?? r.user} className="py-2 text-sm text-gray-800">
            {r.username}
            {r.has_override === true && <p className="text-xs text-gray-500">Answered for this date</p>}
          </li>
        ))}
      </ul>
    </div>
  );
}
